import { useTranslation } from 'react-i18next';

import { CreativePreview } from '@features/campaigns/builder/components/CreativePreview/CreativePreview.tsx';
import { CREATIVE_CATEGORY, CREATIVE_TYPE } from '@features/campaigns/builder/types/creativeType.ts';
import { NoCreatives } from '@features/campaigns/shared/components/Review/NoImages/NoImages';
import { AdProductsData } from '@features/campaigns/shared/containers/Review/Review.dto';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface AdProductsVideoCreativesProps {
  data: AdProductsData;
}

export function AdProductsVideoCreatives({ data }: AdProductsVideoCreativesProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <p className={'subheader'}>{t('review.labels.videoSpot')}</p>
        </div>
      </div>
      {data.videoSpotUrl ? (
        <div className='row'>
          <div className='col-12'>
            <CreativePreview
              creativeUrl={data.videoSpotUrl}
              creativeType={CREATIVE_TYPE.VIDEO}
              creativeCategory={CREATIVE_CATEGORY.VIDEO}
              fileName={data.videoSpotFilename}
              headerText={t('builder.formFields.creativeVideoSpot.modalHeaderText')}
            />
          </div>
        </div>
      ) : (
        <NoCreatives creativeCategory={CREATIVE_CATEGORY.VIDEO} />
      )}
    </>
  );
}
